<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter">
<div class="part">
<p class="noindent_paraf"><span epub:type="pagebreak" id="page_2" title="2">A well-driven train moving smoothly and strongly over a well-laid roadbed offers a traveler advantages and conveniences not to be had in any other form of transportation.</span></p>
<p class="rightr">E. B. White, “Progress and Change”</p>
<p class="common"><img alt="" src="images/common.jpg" style="width: 15%"/></p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Frontmatter06.vue?7171fe2e